import React from "react";
import { bindActionCreators } from "redux";
import { Formik } from "formik";
import { Form, Input, Button, Card } from "antd";
import { connect } from "react-redux";
import { getAuthTokenAndSignInProfessor } from "../../redux/actions/auth";

class SignInStudent extends React.PureComponent {
  render() {
    return (
      <Card title="Sign in" style={{ width: "100%" }}>
        <Formik
          initialValues={{ password: "" }}
          onSubmit={(values, actions) => {
            this.props.getAuthTokenAndSignInProfessor(values);
            actions.setSubmitting(false);
          }}
          render={props => (
            <Form layout="vertical">
              <Form.Item label="Ingresa tu clave secreta">
                <Input
                  type="password"
                  name="password"
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                  value={props.values.password}
                />
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  onClick={props.handleSubmit}
                  variant="contained"
                  color="primary"
                >
                  Submit
                </Button>
              </Form.Item>
            </Form>
          )}
        />
      </Card>
    );
  }
}

const mapStateToProps = state => {};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ getAuthTokenAndSignInProfessor }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignInStudent);
